import React from "react";
import parentServices from "../../../../../services/parent-services";
import { Dialog, DialogContent } from "@mui/material";
import { useAppMutation } from "../../../../../services";
import DiscountCoupon from "./DiscountCoupon";
import AddressDetails from "./AddressDetails";
import PaymentStripe from "./PaymentStripe";

const Index = ({ plan, hide }) => {

  const [showDiscount, setShowDiscount] = React.useState(false);
  const [showAddress, setShowAddress] = React.useState(false);
  const [discountCode, setDiscountCode] = React.useState();
  const [address, setAddress] = React.useState(null);
  const [showStripePayment, setShowStripePayment] = React.useState(false);

  const {
    mutate: showDiscountCode,
    data: promoData,
    isError: pError,
    isSuccess: isPSuccess,
  } = useAppMutation(parentServices.showDiscountCode);

  React.useEffect(() => {
    if (plan.planId) {
      showDiscountCode({ planId: plan.planId });
      setShowStripePayment(false);
      setShowDiscount(false);
      setShowAddress(false);
    }
  }, [plan]);

  React.useEffect(() => {
    if (isPSuccess) {
      setShowDiscount(promoData.show);
    } else if (pError) {
      setShowDiscount(false);
      setShowStripePayment(true);
    }
  }, [isPSuccess, pError]);



  const hideMe = ({ payment, backToAddress } = {}) => {
    setShowStripePayment(false);

    // NEW: Payment back should go to Address
    if (backToAddress) {
      setShowDiscount(false);
      setShowAddress(true);
      return;
    }

    setShowAddress(false);

    if (payment) {
      setShowDiscount(true);
    } else {
      setShowDiscount(false);
      hide();
    }
  };

  if (showDiscount || showAddress || showStripePayment) {
    return (
      <Dialog
        open={!!plan?.planId}
        maxWidth={false}
        PaperProps={{
          sx: {
            width: "100%",
            maxWidth: 500, // ✅ increase as you like (600-720)
            borderRadius: 3,
            overflow: "hidden",
          },
        }}
      >
        <DialogContent
          sx={{
            width: "100%", // ✅ let it fully use Paper width
            p: 0, // ✅ IMPORTANT: remove default padding
            //minHeight: 420,
          }}
        >
          {showDiscount && (
            <DiscountCoupon
              hide={hideMe}
              plan={plan}
              next={({ discountCode }) => {
                setDiscountCode(discountCode);
                setShowDiscount(false);
                //setShowStripePayment(true);
                setShowAddress(true);
              }}
            />
          )}

          {showAddress && (
            <AddressDetails
              hide={hideMe}
              plan={plan}
              defaultValues={address} // keep values if user comes back
              back={() => {
                // If discount screen exists, go back there; otherwise just close
                if (promoData?.show) {
                  setShowAddress(false);
                  setShowDiscount(true);
                } else {
                  hideMe({ payment: false });
                }
              }}
              next={(addr) => {
                setAddress(addr);
                setShowAddress(false);
                setShowStripePayment(true);
              }}
            />
          )}

          {showStripePayment && (
            <div className="notranslate">
              <PaymentStripe
                hide={hideMe}
                plan={plan}
                discountCode={discountCode}
                address={address}
              />
            </div>
          )}
        </DialogContent>
      </Dialog>
    );
  }

  return null;
};

export default Index;
